import {types} from './action';
import initState from '../../reducers/redux-initial-state';

export default (state = initState.accessManagementReducer, action) => {
  switch (action.type) {
    case types.SET_OPERATORS: {
      return {
        ...state,
        operators: action.data,
      };
    }
    case types.SET_EDITING_MODE: {
      return {
        ...state,
        isEditingMode: action.isEditingMode,
      };
    }
    case types.RESET_STATE: {
      return {...initState.accessManagementReducer};
    }
    default:
      return state;
  }
};
